import { createContext } from 'react';
import { AuthContextValues } from './auth-types';
import { AUTH_CONTEXT_VALUES } from './auth-constants';

export const Context = createContext<AuthContextValues>(AUTH_CONTEXT_VALUES);

export const { Provider } = Context;